import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@firebird-web/shared-config';
import { apiEndpoints } from '@firebird-web/shared-constants';
import { CommonUtils } from '@firebird-web/shared-utils';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WeightedSinglerunDropdownService {
  /**
   * getUsGasBcfModelsRun
   * @returns
   */
  public getUsGasBcfModelsRun() {
    const endPointUrl = CommonUtils.populateURLTemplate(
      `${environment.apiDomain}/${apiEndpoints.getUsGasBcfModelsRun}`
    );
    return this.http.get(endPointUrl).pipe(map((resp: any) => resp?.data));
  }

  /**
   * geWeightedModelsRun
   * @returns
   */
  public getWeightedModelsRun(filter?: string) {
    const endPointUrl = CommonUtils.populateURLTemplate(
      `${environment.apiDomain}/${apiEndpoints.getWeightedModelsRun}`
    );

    // Prepare HttpParams if filter exists
    let params = new HttpParams();
    if (filter) {
      params = params.set('filter', filter);
    }

    return this.http
      .get(endPointUrl, { params })
      .pipe(map((resp: any) => resp?.data));
  }

  // constructor
  public constructor(private http: HttpClient) {}
}
